<h4 class="mb-3" *ngIf="showTitle"> {{'orderProcess.payment.choosePersonType.iAm' | translate}}</h4>
<section *ngIf="!showAsRadio">
  <div class="choose-payment-tabs">
    <button *ngFor="let option of PAYMENT_PERSON_TYPE_OPTIONS; let last = last"
            class="btn btn-xl me-3"
            [class.me-3]="!last"
            (click)="personType = option.id"
            [class.btn-primary]="type === option.id"
            [class.btn-outline-primary]="type !== option.id">
      {{option.label}}
    </button>
  </div>
</section>
<section *ngIf="showAsRadio">
  <ui-radio-group
    class="d-block"
    [model]="personTypeOption"
    (modelChange)="personType = $event ? $event.id : null"
    [items]="PAYMENT_PERSON_TYPE_OPTIONS">
  </ui-radio-group>
</section>
